import type { ColumnDef } from '@tanstack/react-table';

import { DataTableColumnHeader } from '@/components/dataTable/ColumnHeader';
import { SystemTransferTypes } from '@/services/systemTransfer/systemTransfer.types';
import { useDynamicLocale } from '@/hoslog-intl';

export function getColumns(t: ReturnType<typeof useDynamicLocale>['t']): ColumnDef<SystemTransferTypes>[] {
  return [
    {
      accessorKey: 'sn',
      header: ({ column }) => <DataTableColumnHeader column={column} title={t('common.page.tableColumn.sn')} />,
      cell: ({ row }) => <div className="font-medium truncate max-w-[10rem]">{row.getValue('sn')}</div>,
      enableSorting: false,
    },
    {
      accessorKey: 'transactionId',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Transaction Id" />,
      cell: ({ row }) => <div className="font-medium truncate max-w-[20rem]">{row.getValue('transactionId')}</div>,
      meta: {
        label: 'Transaction Id',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'transactionDate',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Transaction Date" />,
      cell: ({ row }) => <div>{row.getValue('transactionDate')}</div>,
      meta: {
        label: 'Transaction Date',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'transactionType',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Transaction Type" />,
      cell: ({ row }) => <div>{row.getValue('transactionType')}</div>,
      meta: {
        label: 'Transaction Type',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'userType',
      header: ({ column }) => <DataTableColumnHeader column={column} title="User Type" />,
      cell: ({ row }) => <div>{row.getValue('userType')}</div>,
      meta: {
        label: 'User Type',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'user',
      header: ({ column }) => <DataTableColumnHeader column={column} title="User" />,
      cell: ({ row }) => <div>{row.getValue('user')}</div>,
      meta: {
        label: 'User',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'points',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Points" />,
      cell: ({ row }) => <div>{row.getValue('points')}</div>,
      meta: {
        label: 'Points',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'remarks',
      header: ({ column }) => <DataTableColumnHeader column={column} title="Remarks" />,
      cell: ({ row }) => <div>{row.getValue('remarks')}</div>,
      meta: {
        label: 'Remarks',
      },
      enableHiding: false,
    },
  ];
}
